import { render } from "./perfect.vue?vue&type=template&id=70e37916&scoped=true"
import script from "./perfect.vue?vue&type=script&lang=js"
export * from "./perfect.vue?vue&type=script&lang=js"

import "./perfect.vue?vue&type=style&index=0&id=70e37916&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e37916"]])

export default __exports__